import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { OnDemandDriversService } from '../../on-demand-drivers.service';

@Component({
  selector: 'app-on-demand-drivers-user-device',
  templateUrl: './user-device.component.html',
  styleUrls: ['./user-device.component.scss']
})
export class UserDeviceComponent implements OnInit, OnChanges {
  @Input() selected: number;
  userDevices: any = [];

  constructor(private onDemandDriversService: OnDemandDriversService, private toastrAlertHelper: ToastrAlertHelper) {
  }

  ngOnInit() {
    this.getUserDeviceData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      this.userDevices = [];
      this.getUserDeviceData();
    }
  }

  private getUserDeviceData() {
    this.onDemandDriversService.getUserDeviceById(this.selected).subscribe(
      data => {
        this.userDevices = data;
      },
      error => {
        this.toastrAlertHelper.error(error.message);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/user-device/user-device.component.ts